export const MEDIA_VIDEO = 'MEDIA_VIDEO'
export const MEDIA_IMAGE = 'MEDIA_IMAGE'
export const MEDIA_IMAGE_VIDEO = 'MEDIA_IMAGE_VIDEO'

export const REQUEST_POSTS = 'REQUEST_POSTS'
export const RECEIVE_POSTS = 'RECEIVE_POSTS'
export const RECEIVE_POSTS_ERROR = 'RECEIVE_POSTS_ERROR'
export const SELECT_SUBREDDIT = 'SELECT_SUBREDDIT'
export const INVALIDATE_SUBREDDIT = 'INVALIDATE_SUBREDDIT'
export const REMOVE_SUBREDDIT = 'REMOVE_SUBREDDIT'
export const SELECT_SUBREDDIT_SCOPE = 'SELECT_SUBREDDIT_SCOPE'

export const NEXT_POST = 'NEXT_POST'
export const PREVIOUS_POST = 'PREVIOUS_POST'
export const SELECT_POST = 'SELECT_POST'
export const MEDIA_FALLBACK = 'MEDIA_FALLBACK'

export const REQUEST_COMMENTS = 'REQUEST_COMMENTS'
export const RECEIVE_COMMENTS = 'RECEIVE_COMMENTS'
export const RECEIVE_COMMENTS_ERROR = 'RECEIVE_COMMENTS_ERROR'

export const REQUEST_REPLIES = 'REQUEST_REPLIES'
export const RECEIVE_REPLIES = 'RECEIVE_REPLIES'
export const RECEIVE_REPLIES_ERROR = 'RECEIVE_REPLIES_ERROR'

export const TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN'
export const ENABLE_FULLSCREEN = 'ENABLE_FULLSCREEN'
export const DISABLE_FULLSCREEN = 'DISABLE_FULLSCREEN'
export const TOGGLE_AUTO_ADVANCE = 'TOGGLE_AUTO_ADVANCE'
export const TOGGLE_PLAY = 'TOGGLE_PLAY'
export const TOGGLE_THEME_MODE = 'TOGGLE_THEME_MODE'
export const TOGGLE_NSFW = 'TOGGLE_NSFW'
export const TOGGLE_SHOW_VIDEOS = 'TOGGLE_SHOW_VIDEOS'
export const TOGGLE_SHOW_IMAGES = 'TOGGLE_SHOW_IMAGES'

export const ENABLE_KEYBORAD_CONTROLS = 'ENABLE_KEYBORAD_CONTROLS'
export const DISABLE_KEYBORAD_CONTROLS = 'DISABLE_KEYBORAD_CONTROLS'

export const PLAYER_SCAN_FORWARDS = 'PLAYER_SCAN_FORWARDS'
export const PLAYER_SCAN_BACKWARDS = 'PLAYER_SCAN_BACKWARDS'
export const PLAYER_SCAN_ACK = 'PLAYER_SCAN_ACK'
export const PLAYER_JUMP_TO = 'PLAYER_JUMP_TO'
export const PLAYER_JUMP_ACK = 'PLAYER_JUMP_ACK'
export const PLAYER_VOLUME_UP = 'PLAYER_VOLUME_UP'
export const PLAYER_VOLUME_DOWN = 'PLAYER_VOLUME_DOWN'

export const DEFAULT_SUBREDDITS = [
  'videos',
  'documentaries',
  'politicalvideos',
  'artisanvideos',
  'all',
]

export const DEFAULT_SUBREDDIT = DEFAULT_SUBREDDITS[0]

export const THUMBNAIL_WIDTH = 140
export const THUMBNAIL_HEIGHT = 105

export const KNOWN_EMBED_REQUIRED_PROVIDERS = [
  'Gyfcat',
]
